import request from '@/utils/request'
import { Base64 } from 'js-base64'

export async function ssoLogin(data) {
  return request({
    url: `${context.uc}/sso/auth?rtoken=${data.token}&utoken=${data.rtoken}`,
  })
}

export async function refreshToken() {
  return request({
    url: `${context.uc}/refreshToken`,
  })
}

export function getUserInfo() {
  const params = {
    url: `${context.uc}/api/user/v1/user/getByAccount`,
    method: 'post',
  }
  return request(params)
}

// 通过 account 获取用户详细信息
export function getDetailByAccountOrId(account) {
  const url = `${context.uc}/api/user/v1/user/getDetailByAccountOrId`
  return request.post(url, {
    accountOrId: Base64.encode(account),
  })
}

// 根据名称 和 id获取人员信息
export function getAccountById(name, id) {
  const requestParams = {
    querys: [
      {
        property: 'fullname',
        value: name,
        group: 'main',
        operation: 'LIKE',
        relation: 'OR',
      },
      {
        property: 'account',
        value: name,
        group: 'main',
        operation: 'LIKE',
        relation: 'OR',
      },
    ],
    pageBean: {
      page: 1,
      pageSize: 20,
    },
  }
  const url = `${context.uc}/api/user/v1/users/queryUserWithMainOrgPost`
  return new Promise((resolve) => {
    request
      .post(url, Base64.encode(JSON.stringify(requestParams)))
      .then(({ rows }) => {
        if (rows.length) {
          resolve(rows.filter((row) => row.id === id))
        } else {
          resolve([])
        }
      })
  })
}

export function getUserList(searchStr, page, pageSize) {
  const params = {
    querys: [
      {
        property: 'fullname',
        value: searchStr,
        group: 'main',
        operation: 'LIKE',
        relation: 'OR',
      },
      {
        property: 'account',
        value: searchStr,
        group: 'main',
        operation: 'LIKE',
        relation: 'OR',
      },
      {
        property: 'fullNamePinYin',
        value: searchStr,
        group: 'main',
        operation: 'LIKE',
        relation: 'OR',
      },
      {
        property: 'status',
        value: 1, // 1 在职 -2 离职
        group: 'main',
        operation: 'EQUAL',
        relation: 'AND',
      },
    ],
    pageBean: {
      page,
      pageSize,
    },
  }

  return request.post(
    `${context.uc}/api/user/v1/users/queryUserWithMainOrgPost`,
    Base64.encode(JSON.stringify(params))
  )
}

// 获取openId
export function getOpenId(account) {
  return request.post(
    'https://pfgateway.transsion.com:9199/service-user-common/gl-user-common/LarkAuthenticationRemoteService/getOpenId',
    { data: account, type: 'employeeNo' }
  )
}
